import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/plastic-surgery-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function PlasticSurgery() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "Plastic and Micro Vascular Surgery");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        {/* Navbar starts here  */}

            <Navbar />

        {/* Navbar ends here */}

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>Plastic and Microvascular Surgery</p>
                
                <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                  <p className="page-subtitle">
                    Comprehensive Services in Plastic and Microvascular Surgery 
                    <br/>
                    for Aesthetic and Reconstructive Needs.
                  </p>
                </div>

                <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                      Comprehensive Services in Plastic and Microvascular Surgery for Aesthetic and Reconstructive Needs.
                    </p>
                </div>

                <div className="page-box">
                    <div className="box-content">
                        <p>Caritas Matha Hospital's Plastic and Microvascular Surgery department specializes in advanced reconstructive and cosmetic procedures. Our skilled team of surgeons offers a wide range of treatments, including microvascular surgeries, to enhance appearance and restore function.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="Plastic Surgery Banner"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="dept-section">
            <div
            ref={sidebarRef}
            className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
            >
            {["overview", "treatment", "facilities", "doctors"].map((section) => (
                <p
                key={section}
                className={`title ${activeSection === section ? "active" : ""}`}
                onClick={() => scrollToSection(section)}
                >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                {activeSection === section && (
                    <FontAwesomeIcon
                    icon={faChevronRight}
                    className="chevron-icon"
                    />
                )}
                </p>
            ))}
            </div>
            <div ref={contentRef} className="contents">
                <div ref={sectionsRef.overview} className="overview-content">
                    <p className="content-heading">Overview</p>
                    {/* Overview content here */}
                    <p>The Department of Plastic, Aesthetic & Reconstructive Surgery at Caritas Matha Hospital is a leading center for advanced medical care in the region. Specializing in plastic, aesthetic/cosmetic, reconstructive, dermatology, and hand surgery, our expert team of highly experienced surgeons offers a comprehensive range of specialized services. We are dedicated to enhancing both function and appearance through personalized care that addresses the unique needs and desires of each patient.</p>

                    <p>Our department prides itself on delivering innovative solutions tailored to meet the diverse needs of our patients. Whether performing complex reconstructive surgeries to restore lost function or aesthetic procedures to enhance natural beauty, our surgeons utilize the latest advancements in surgical techniques and technology. Each treatment plan is carefully crafted to ensure optimal outcomes and patient satisfaction.</p>

                    <p>At Caritas Matha Hospital, patient safety and comfort are paramount. Our state-of-the-art facilities and modern amenities provide a supportive environment for recovery and rehabilitation. From initial consultation through to post-operative care, our dedicated team of healthcare professionals is committed to delivering compassionate and comprehensive care. We strive to empower our patients with knowledge and support throughout their surgical journey, promoting confidence and well-being every step of the way.</p>

                </div>
                <div ref={sectionsRef.treatment} className="treatment-content">
                    <p className="content-heading">Treatment</p>
                    {/* Treatment content here */}
                    
                    <ul>

                        <li>
                          <span className="subtitle">Microvascular Surgery : </span>Advanced techniques for intricate reconstructions requiring precise tissue transfer and vascular connections.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Cleft Lip and Palate Surgeries : </span>Corrective procedures to address congenital deformities of the lip and palate.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Reconstruction for Head & Neck Cancers : </span>Surgical interventions to restore form and function following cancer treatment.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Post-Mastectomy Breast Reconstruction : </span>Options for restoring breast shape and symmetry after mastectomy.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Soft Tissue Reconstruction for Limb Trauma : </span>Procedures to repair and reconstruct soft tissue injuries and defects caused by trauma.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Lymphoedema Management : </span>Techniques to alleviate swelling and manage complications related to lymphatic system disorders.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Reconstruction for Facial Nerve Paralysis : </span>Surgical solutions to restore facial movement and symmetry in cases of nerve damage.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Peripheral Nerve Surgery : </span>Treatments for conditions affecting peripheral nerves, including injuries and compressive neuropathies.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Management of Scars and Keloids : </span>Techniques to improve the appearance and function of scars and keloid formations.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Reconstruction of Congenital Deformities : </span>Surgical corrections for congenital anomalies affecting various parts of the body.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Hypospadias Operations : </span>Corrective surgeries for urethral malformations in male patients.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Ear Reconstruction : </span>Procedures to reconstruct or enhance the appearance of the ear.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Pharyngoplasty and Alveolar Bone Grafting : </span>Surgical interventions to address defects in the palate and alveolar bone.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Reconstructive Surgeries for Bed Sores & Ulcers : </span>Techniques to repair and manage skin wounds and ulcers.</li>
                        <br/>

                        <li>
                          <span className="subtitle">Reconstructive Surgery for Burn Deformities : </span>Restorative procedures for patients with burn-related deformities.</li>
                        <br/>

                    </ul>

                </div>
                <div ref={sectionsRef.facilities} className="facilities-content">
                    <p className="content-heading">Facilities</p>
                    {/* Facilities content here */}

                    <br/>
                    <ul>
                        <li>State-of-the-art operation theaters equipped for precision surgeries</li>
                        <br/>

                        <li>Advanced imaging systems including C-arm for accurate diagnostics and surgical planning</li>
                        <br/>

                        <li>Dedicated facilities for microvascular surgeries</li>
                        <br/>

                        <li>Comprehensive post-operative care units</li>
                        <br/>

                        <li>Specialized equipment for cosmetic and reconstructive procedures</li>
                        <br/>

                        <li>Multidisciplinary collaboration with other specialties for integrated patient care</li>
                        <br/>

                        <li>High standards of hygiene and infection control measures</li>
                        <br/>

                        <li>GFC injection for Rejuvenation of face( melasma, Acne scars, face pigmentations)</li>
                        <br/>

                        <li>2 GFC injection/ PRP injection for treatment of alopecia and Hair fall</li>
                        <br/>

                        <li>3 Microblading and Micropigmentation for EyE brow creation</li>
                        <br/>

                        <li>4 Body Contouring Surgeries( Liposuction) for Gynecomastia, Abdominoplasty procedures.</li>
                        <br/>
                    </ul>

        
                </div>

                <div ref={sectionsRef.doctors} className="doctors">
                    <p className="content-heading">Doctors</p>

                    {error && <p>{error}</p>}
                    {filteredDoctors.length > 0 ? (
                        <div className='doctorbox-container'>
                            {filteredDoctors.map(doctor => (
                              <div key={doctor.id} className="doctorbox">
                                <div className="doctor-box">
                                    <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    <div className='doctor-details'>
                                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                        <p>{doctor['designation']}</p>
                                        <p>{ doctor.available_time }</p>
                                        <br/>
                                        {parseInt(doctor.appointment_enabled) === 1 && (
                                            <p>
                                                <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                    Book An Appointment <FaChevronRight />
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='arrow-section'>
                                    <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                </div>
                              </div>
                            ))}
                        </div>
                    ) : (
                        !error && <p>No doctors available in this department.</p>
                    )}
                </div>
            </div>
        </section>

        {/* Footer Starts here */}

            <Footer ref={footerRef} />

        {/* Footer ends here */}
    </div>
  );
}

export default PlasticSurgery;